export const EMAIL = 'EMAIL'
export const FIRST_NAME = 'FIRST_NAME'
export const LAST_NAME = 'LAST_NAME'
export const PHONE = 'PHONE'
export const TEXT = 'TEXT'
export const WORKFLOWMAX_COMPANY = 'WORKFLOWMAX_COMPANY'
